import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class LandActionsApi extends ApiModule {
	constructor() {
		super(ModulesMap.LAND_ACTIONS, {
			entity: 'land_actions',
		})
	}
}
